import React, { useState } from "react";
import Scrollspy from "react-scrollspy";
import logo from "../assets/layout/images/logo4.jpg";

const Navbar = () => {
  const [activeNav, setActiveNav] = useState(false);

  const clickNavButton = (e) => {
    setActiveNav(!activeNav);
    /* document.querySelector(e.target.hash).scrollIntoView({
      behavior: "auto"
    }); */
    //let rect = document.querySelector(e.target.hash).getBoundingClientRect();
    e.preventDefault();
    window.scrollTo(0, document.querySelector(e.target.hash).offsetTop);
  };

  return (
    <div className="header-nav">
      <nav className="navbar navbar-expand-lg bg-transparent">
        <div className="container-fluid">
          <div>
            <a className="navbar-brand" href="/">
              <img src={logo} alt="아미소프트" width="150" height="45" className="d-inline-block align-text-middle" />
            </a>
          </div>
          <button className="navbar-toggler p-1" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" onClick={clickNavButton}>
            <span className={activeNav ? "bi bi-x-lg p-2" : "bi bi-list p-2"}></span>
          </button>
          <div id="site-menu" className={"collapse navbar-collapse mx-5" + (activeNav ? " show" : "")}>
            {/* <ul className="nav navbar-nav me-auto mb-2 mb-lg-0"> */}
            <Scrollspy items={["home", "intro", "project", "contact"]} currentClassName="active" className="nav navbar-nav">
              <li className="nav-item mx-3 d-none">
                <a className="nav-link" href="#home" onClick={clickNavButton}>
                  Home
                </a>
              </li>
              <li className="nav-item mx-3">
                <a className="nav-link" href="#intro" onClick={clickNavButton}>
                  (주)아미소프트
                </a>
              </li>
              <li className="nav-item mx-3">
                <a className="nav-link" href="#project" onClick={clickNavButton}>
                  주요사업
                </a>
              </li>
              <li className="nav-item mx-3">
                <a className="nav-link" href="#contact" onClick={clickNavButton}>
                  CONTACT US
                </a>
              </li>
            </Scrollspy>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
